import { CoinsTransferArea } from "./components/coin-transfer-area";

export const InfoTransfer = () => {
  const openFromApp = localStorage.getItem("@openFromApp");
  const token = localStorage.getItem("@token");

  if (!token) {
    return null;
  }

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        background: "#f0f3fc",
        minHeight: "100vh",
      }}
    >
      {!openFromApp && (
        <div
          style={{
            background: "#ffffff",
            padding: "10px",
          }}
        >
          <h2>Coins transfer</h2>
        </div>
      )}

      <CoinsTransferArea />
    </div>
  );
};
